package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.Incidencia
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import waldo.sankan.lineamunicipalkmp.web.screens.AdminPanelViewModel
import kotlin.js.Date

// ========================================================================
// === SECCIÓN DE FUNCIONES DE UTILIDAD (ESTÁNDAR IMPERIAL) ===
// ========================================================================

private fun formatTimestampWithTime(timestamp: Any?): String {
    val longTime = when (timestamp) {
        is Long -> timestamp
        is Double -> timestamp.toLong()
        is String -> timestamp.toLongOrNull()
        else -> null
    } ?: return "N/A"

    val date = Date(longTime)
    val dia = date.getDate().toString().padStart(2, '0')
    val mes = (date.getMonth() + 1).toString().padStart(2, '0')
    val anio = date.getFullYear()
    val hora = date.getHours().toString().padStart(2, '0')
    val minutos = date.getMinutes().toString().padStart(2, '0')
    return "$dia/$mes/$anio $hora:$minutos"
}

@Composable
fun CamerasVerificationScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    val incidenciasFiltradas by viewModel.incidenciasFiltradas.collectAsState()
    val rol = uiState.rolAdmin?.rol

    // --- CONTENEDOR MAESTRO (CONGELA LA PANTALLA) ---
    Div({
        style {
            height(100.vh)
            width(100.vw)
            backgroundColor(Color("#1976D2"))
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            fontFamily("sans-serif")
            property("overflow", "hidden")
            boxSizing("border-box")
        }
    }) {
        // --- 1. CABECERA DE GALA (FIJA) ---
        Div({
            style {
                display(DisplayStyle.Flex)
                property("border-bottom", "2px solid #1565C0")
                flexShrink(0)
            }
        }) {
            Div({
                style {
                    width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                }
            }) {
                Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                    Img(src = "logo_icon.svg", attrs = { style { height(100.px) } })
                    H2({ style { fontSize(20.px); color(Color.white); margin(0.px) } }) {
                        Span({ style { fontWeight("normal") } }) { Text("Linea") }
                        Span({ style { fontWeight("bold") } }) { Text("Muni") }
                    }
                }
            }

            Div({
                style {
                    width(90.percent); padding(16.px, 24.px); boxSizing("border-box")
                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(12.px)
                }
            }) {
                H1({
                    style {
                        color(Color.white); fontSize(28.px); fontWeight(700);
                        textAlign("center"); margin(0.px); paddingTop(10.px)
                    }
                }) { Text("🎥 CENTRAL DE VIGILANCIA ESTADIO") }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(12.px)
                        backgroundColor(Color.white)
                        padding(16.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 4px 6px rgba(0,0,0,0.1)")
                        boxSizing("border-box")
                    }
                }) {
                    Div({ style { display(DisplayStyle.Flex); gap(12.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {

                            FilterDropdown(
                                label = "Tipo:",
                                selectedValue = uiState.filtroTipo,
                                options = uiState.incidencias.mapNotNull { it.tipoIncidenciaDisplayName }.distinct().sorted(),
                                onValueChanged = { viewModel.onFiltroTipoChanged(it) }
                            )


                        FilterDropdown(
                            label = "Mes:",
                            selectedValue = uiState.filtroMes,
                            options = uiState.mesesDisponibles,
                            onValueChanged = { viewModel.onFiltroMesChanged(it) },
                            optionDisplayNames = uiState.mesesDisponibles.associateWith {
                                val parts = it.split("-")
                                val year = parts[0].toInt()
                                val month = parts[1].toInt()
                                Date(year, month - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
                            }
                        )
                        FilterDropdown(
                            label = "Estado:",
                            selectedValue = uiState.filtroEstado,
                            options = listOf("EN_PROCESO", "SOLUCIONADO", "RECHAZADO", "VERIFICADO"),
                            onValueChanged = { viewModel.onFiltroEstadoChanged(it) }
                        )
                        FilterDropdown(
                            label = "Orden:",
                            selectedValue = uiState.ordenPorFecha,
                            options = listOf("Recientes", "Antiguas"),
                            onValueChanged = { it?.let { viewModel.onOrdenChanged(it) } },
                            isNullable = false
                        )

                        Div({ style { flex(1) } })

                        ActionButton("+ Reportar Hallazgo", Color("#34A853")) { viewModel.onShowIngresoIncidenciaClicked() }
                        ActionButton("Mapa", Color("#1A73E8")) { viewModel.onShowMapClicked() }
                        ActionButton("\uD83D\uDDFA\uFE0F Plan Cuadrante", Color("#1A73E8")) { viewModel.onShowPlanCuadranteModal() }

                        Button(attrs = {
                            onClick { viewModel.logout() }
                            style {
                                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold")
                                color(Color.white); backgroundColor(Color("#AD1457"))
                                borderRadius(8.px); border(1.px, LineStyle.Solid, Color.black); cursor("pointer")
                            }
                        }) { Text("Cerrar Sesión") }
                    }
                }
            }
        }

        // --- 2. ZONA DE LA TABLA (CON SCROLL INDEPENDIENTE) ---
        Div({
            style {
                flex(1)
                padding(24.px)
                boxSizing("border-box")
                property("overflow-y", "auto") // ¡ORDEN: SOLO AQUÍ HAY SCROLL!
            }
        }) {
            Div({
                style {
                    backgroundColor(Color.white)
                    padding(24.px)
                    borderRadius(12.px)
                    property("box-shadow", "0 4px 10px rgba(0,0,0,0.1)")
                    boxSizing("border-box")
                    minHeight(100.percent)
                }
            }) {
                if (uiState.isLoading) {
                    Div({ style { textAlign("center"); padding(40.px) } }) { Text("Capturando datos del Estadio...") }
                } else {
                    CamerasTable(incidenciasFiltradas, onIncidenciaClick = { viewModel.onIncidenciaSelected(it) })
                }
            }
        }
    }
}

@Composable
fun CamerasTable(incidencias: List<Incidencia>, onIncidenciaClick: (Incidencia) -> Unit) {
    Div({ style { marginBottom(16.px) } }) {
        H3({ style { margin(0.px); color(Color("#333")) } }) { Text("Hallazgos Detectados: ${incidencias.size}") }
    }

    Table({
        style { width(100.percent); property("border-collapse", "collapse"); borderRadius(8.px); property("overflow", "hidden") }
    }) {
        Thead {
            Tr({ style { backgroundColor(Color("#AD1457")) } }) { // Color Granate Estadio
                listOf("ID", "Tipo Hallazgo", "Sector / Comuna", "Fecha Captura", "Estado", "Mando").forEach {
                    Th({ style { padding(16.px); textAlign("left"); fontSize(16.px); color(Color.white); property("border-bottom", "2px solid #EEE") } }) { Text(it) }
                }
            }
        }
        Tbody {
            incidencias.forEach { incidencia ->
                val rowBgColor = when (incidencia.estado.uppercase()) {
                    "SOLUCIONADO" -> "#E8F5E9"
                    "RECHAZADO" -> "#FFEBEE"
                    "EN_PROCESO" -> "#FFF9C4"
                    "VERIFICADO" -> "#E3F2FD"
                    else -> "#FFFFFF"
                }

                key(incidencia.id) {
                    Tr({
                        style {
                            backgroundColor(Color(rowBgColor))
                            property("border-bottom", "1px solid black")
                        }
                    }) {
                        Td({ style { padding(12.px); fontWeight("bold") } }) { Text(incidencia.id.take(8)) }
                        Td({ style { padding(12.px) } }) { Text(incidencia.tipoIncidenciaDisplayName ?: "General") }
                        Td({ style { padding(12.px) } }) { Text("${incidencia.sectorIncidencia ?: "GENERAL"} - ${incidencia.comunaDisplayName ?: "Arica"}") }
                        Td({ style { padding(12.px) } }) { Text(formatTimestampWithTime(incidencia.fechaCreacion)) }
                        Td({ style { padding(12.px) } }) { StatusBadge(incidencia.estado) }
                        Td({ style { padding(12.px) } }) {
                            Button(attrs = {
                                onClick { onIncidenciaClick(incidencia) }
                                style {
                                    padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                                    backgroundColor(Color("#AD1457")); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
                                }
                            }) { Text("Detalles") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StatusBadge(estado: String) {
    val colorHex = when (estado.uppercase()) {
        "SOLUCIONADO" -> "#4CAF50"
        "RECHAZADO" -> "#F44336"
        "EN_PROCESO" -> "#FFC107"
        "VERIFICADO" -> "#3F51B5"
        else -> "#808080"
    }
    Span({
        style {
            padding(8.px, 12.px); fontSize(12.px); fontWeight("bold"); color(Color.white)
            backgroundColor(Color(colorHex)); borderRadius(20.px); border(1.px, LineStyle.Solid, Color.black)
        }
    }) { Text(estado) }
}

@Composable
private fun ActionButton(label: String, bgColor: CSSColorValue, onClick: () -> Unit) {
    Button(attrs = {
        onClick { onClick() }
        style {
            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
            backgroundColor(bgColor); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
            property("transition", "all 0.2s ease")
            property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
        }
    }) { Text(label) }
}